var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "public-app" },
    [
      _c(
        "el-button",
        {
          staticClass: "create-app-btn",
          attrs: { type: "primary", size: "14" },
          on: {
            click: function ($event) {
              return _vm.handleCreateApp(_vm.allNull ? "create" : "edit")
            },
          },
        },
        [_vm._v(_vm._s(_vm.allNull ? "创建App" : "编辑App"))]
      ),
      _c("createAppDialog", {
        ref: "createApp",
        attrs: { "apply-data": _vm.applyData },
        on: { "query-app": _vm.queryApp },
      }),
      !_vm.allNull
        ? _c("div", { staticClass: "app-wrap" }, [
            _c("div", { staticClass: "apply-name" }, [
              _vm._v("应用名称：" + _vm._s(_vm.applyData.appName)),
            ]),
            _c("div", { staticClass: "app-box" }, [
              _c("div", { staticClass: "modules package-name" }, [
                _c("div", [
                  _vm._v(
                    "Android 应用包名：" + _vm._s(_vm.applyData.androidAppName)
                  ),
                ]),
                _c("div", [
                  _vm._v("iOS 应用包名：" + _vm._s(_vm.applyData.iosAppName)),
                ]),
              ]),
              _c("div", { staticClass: "modules identify-wrap" }, [
                _c("div", { staticClass: "copy-box" }, [
                  _c("span", [_vm._v("AppID：")]),
                  _c(
                    "span",
                    {
                      staticClass: "identifying",
                      attrs: {
                        id: "copyAndroidId",
                        title: _vm.applyData.androidAppId,
                      },
                    },
                    [_vm._v(_vm._s(_vm.applyData.androidAppId))]
                  ),
                  _c("i", {
                    staticClass: "iconfont icon-copy",
                    staticStyle: { "font-size": "24px" },
                    on: {
                      click: function ($event) {
                        return _vm.copyText("copyAndroidId")
                      },
                    },
                  }),
                ]),
                _c("div", { staticClass: "copy-box" }, [
                  _c("span", [_vm._v("AppID：")]),
                  _c(
                    "span",
                    {
                      staticClass: "identifying",
                      attrs: { id: "copyIOSId", title: _vm.applyData.iosAppId },
                    },
                    [_vm._v(_vm._s(_vm.applyData.iosAppId))]
                  ),
                  _c("i", {
                    staticClass: "iconfont icon-copy",
                    staticStyle: { "font-size": "24px" },
                    on: {
                      click: function ($event) {
                        return _vm.copyText("copyIOSId")
                      },
                    },
                  }),
                ]),
              ]),
              _c("div", { staticClass: "modules identify-wrap" }, [
                _c("div", { staticClass: "copy-box" }, [
                  _c("span", [_vm._v("Appkey：")]),
                  _c(
                    "span",
                    {
                      staticClass: "identifying",
                      attrs: {
                        id: "copyAndroidKey",
                        title: _vm.applyData.androidAppKey,
                      },
                    },
                    [_vm._v(_vm._s(_vm.applyData.androidAppKey))]
                  ),
                  _c("i", {
                    staticClass: "iconfont icon-copy",
                    staticStyle: { "font-size": "24px" },
                    on: {
                      click: function ($event) {
                        return _vm.copyText("copyAndroidKey")
                      },
                    },
                  }),
                ]),
                _c("div", [
                  _c("span", [_vm._v("Appkey：")]),
                  _c(
                    "span",
                    {
                      staticClass: "identifying",
                      attrs: {
                        id: "copyIOSKey",
                        title: _vm.applyData.iosAppKey,
                      },
                    },
                    [_vm._v(_vm._s(_vm.applyData.iosAppKey))]
                  ),
                  _c("i", {
                    staticClass: "iconfont icon-copy",
                    staticStyle: { "font-size": "24px" },
                    on: {
                      click: function ($event) {
                        return _vm.copyText("copyIOSKey")
                      },
                    },
                  }),
                ]),
              ]),
            ]),
          ])
        : _vm._e(),
      !_vm.allNull
        ? _c("tableList", {
            ref: "tableList",
            attrs: { "apply-data": _vm.applyData },
            on: { "custom-event": _vm.handleVersion },
          })
        : _vm._e(),
      _c("addOrEditVersion", {
        ref: "addVersion",
        attrs: {
          "apply-data": _vm.applyData,
          "active-name": _vm.activeName,
          "version-add-or-edit": _vm.versionAddOrEdit,
          "version-row": _vm.versionRow,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }